import * as log from 'loglevel';
import "TweenMax";
import "ScrollToPlugin";
import {bootstrapApp} from "./embed/BootstrapApp";

var styles = require('../scss/power-patrol.scss');

//  set log level

log.setLevel(5);

//  bootstrap the app

bootstrapApp();



// WEBPACK FOOTER //
// ./src/ts/Main.ts